class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.loading = false;
    this.nextUrl = null;
    this.observer = null;
  }

  connectedCallback() {
    this.grid = this.querySelector('#product-grid');
    this.nextLink = this.querySelector('.next-infinite');

    if (!this.grid || !this.nextLink) return;

    this.nextUrl = this.nextLink.href;

    this.createLoader();
    this.initObserver();
  }

  createLoader() {
    this.loader = this.querySelector('.infinite-scroll-loader');

    if (!this.loader) {
      this.loader = document.createElement('div');
      this.loader.className = 'infinite-scroll-loader';
      this.loader.innerHTML = `
        <span class="infinite-scroll-loader__spinner"></span>
      `;
      this.loader.hidden = true;
      this.appendChild(this.loader);
    }
  }

  initObserver() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        this.loadNextPage();
      },
      {
        rootMargin: '0px 0px 500px 0px'
      }
    );

    this.observer.observe(this.nextLink);
  }

  async loadNextPage() {
    if (this.loading || !this.nextUrl) return;

    this.loading = true;
    this.loader.hidden = false;

    // 同じページを何度も監視しない
    this.observer?.unobserve(this.nextLink);

    try {
      const response = await fetch(this.nextUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const html = await response.text();

      const doc = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const products = [
        ...doc.querySelectorAll('#product-grid > li')
      ];

      if (!products.length) {
        this.finish();
        return;
      }

      // 現在の商品数からorderを決定
      const startOrder =
        this.grid.querySelectorAll(':scope > li').length + 1;

      // 今回取得したページの商品をすべて追加
      products.forEach((product, index) => {
        product.style.order = startOrder + index;
        this.grid.appendChild(product);
      });
      console.dir(doc.querySelector('.next-infinite'));

      // 次ページを取得
      const newNextLink = doc.querySelector('.next-infinite');

      if (newNextLink) {
        this.nextUrl = newNextLink.href;
        this.nextLink.href = this.nextUrl;

        this.observer?.observe(this.nextLink);
      } else {
        this.finish();
      }

    } catch (error) {
      console.error(
        '商品一覧の読み込みに失敗しました:',
        error
      );

      // エラー時は再度読み込み可能にする
      this.observer?.observe(this.nextLink);

    } finally {
      this.loading = false;
      this.loader.hidden = true;
    }
  }

  finish() {
    this.nextUrl = null;

    this.observer?.disconnect();

    this.nextLink?.remove();

    this.loader?.remove();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define(
  'infinite-scroll',
  InfiniteScroll
);